import Authentication from '../Authentication';
import {Serialize} from 'cerialize';
import EntityAware from "../entity/EntityAware";
import environment from "environment";

export default class Parameter {

  private data: any = null;

  private header: object = {
    'Content-Type': 'application/json'
  };

  private url: string = '';

  public static methods: any = {
    DELETE: 'DELETE',
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
  };

  public method: any = Parameter.methods.GET;

  public showNotification: boolean = true;

  public timeout: number = environment['MAX_TIMEOUT'];

  constructor(data: any = null) {
    const valid: Boolean = ['number', 'string', 'object']
        .some((item: string) => typeof data === item);

    if (valid) {
      this.data = data;
    }

    if (Authentication.isLogin()) {
      const token: any = {'Authorization': `Bearer ${Authentication.getUser('token')}`};

      this.header = Object.assign({}, this.header, token);
    }
  }

  public setMethod(value: any) {
    this.method = value;

    return this;
  }

  public setTimeout(value: number) {
    this.timeout = value || environment['MAX_TIMEOUT'];

    return this;
  }

  public setEnableNotif(param: boolean) {
    this.showNotification = param;

    return this;
  }

  public setHeader(header: any = null) {
    if (header) {
      this.header = Object.assign({}, this.header, header);
    }

    return this;
  }

  public setUrl(value: string, suffix: any = null) {
    const valid = value && value.length;

    if (valid) {
      this.url = value;
    }

    const validStringSuffix: boolean = Boolean(suffix) && typeof suffix === 'string' || typeof suffix === 'number';
    const validObjectSuffix: boolean = Boolean(suffix) && Object.keys(suffix).length > 0;

    if (validStringSuffix) {
      this.url = this.url + suffix;
    } else if (validObjectSuffix) {
      let stringSuffix = Object.keys(suffix).reduce((accu: string, item: string, index: number) => {
        return accu + `${(index === 0) ? '?' : '&'}${item}=${suffix[item]}`;
      }, '');

      this.url = this.url + stringSuffix;
    }

    return this;
  }

  public getUrl() {
    return this.url;
  }

  public getHeader() {
    if (this.data && this.data instanceof FormData && this.header['Content-Type']) {
      this.header['Content-Type'] = false;
    }

    return this.header;
  }

  public getMethod() {
    return this.method;
  }

  public getData() {
    return this.data;
  }

  public serializeData(serializer: EntityAware = null) {
    if (serializer) {
      this.data = Serialize(this.data, serializer);
    }

    return this;
  }
}
